import React from 'react';
import "./style.css";

const GooglePlayApp = () => {
    return (
        <a href='https://play.google.com/store/apps/details?id=com.bluqsafe&hl=pl&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
           target="_blank"
           rel="noopener noreferrer"
        >
            <img
                alt='pobierz z Google Play'
                src='https://play.google.com/intl/en_us/badges/static/images/badges/pl_badge_web_generic.png'
                className="storeIcon"
            />
        </a>
    );
};

export default GooglePlayApp;
